import React, { useState } from 'react';
import { CheckCircle2, CornerUpLeft, ShieldCheck, XCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/Button';
import { Textarea } from '../../components/ui/Textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/Dialog';
import { PageHeader } from '../../components/admin/PageHeader';
import { WorkflowStepper } from '../../components/admin/WorkflowStepper';
import { Panel } from '../../components/Panel';
import { StatusBadge } from '../../components/StatusBadge';
import { A4Frame } from '../../components/notice/A4Frame';
import { ScannedNotice } from '../../components/notice/ScannedNotice';
import { useDemo } from '../../contexts/DemoContext';
import { ocrFields } from '../../data/sampleCase';
import { toBn } from '../../utils/bangla';
const checklist = ['মামলা নম্বর সঠিক', 'গাড়ির নম্বর সঠিক', 'মালিকের তথ্য সঠিক', 'অপরাধের তথ্য সঠিক', 'হাজিরার তথ্য সঠিক', 'মূল নোটিশের সাথে মিল রয়েছে'];
export function DataValidation() {
  const navigate = useNavigate();
  const {
    record,
    correctedKeys,
    user,
    completeStage
  } = useDemo();
  const [checked, setChecked] = useState<boolean[]>(checklist.map(() => false));
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');
  const [cancelOpen, setCancelOpen] = useState(false);
  const all = checked.every(Boolean);
  const validate = () => {
    if (!all) return setError('যাচাইকৃত হিসেবে চিহ্নিত করতে সকল চেকলিস্ট আইটেম নিশ্চিত করুন।');
    completeStage(4);
    toast.success('রেকর্ডটি যাচাইকৃত হিসেবে চিহ্নিত হয়েছে', {
      description: 'অনুমোদনকারী কর্মকর্তার কাছে পাঠানো হয়েছে'
    });
    navigate('/admin/approval');
  };
  const sendBack = () => {
    if (!comment.trim()) return setError('সংশোধনের জন্য ফেরত পাঠাতে মন্তব্য আবশ্যক।');
    toast.warning('সংশোধনের জন্য ফেরত পাঠানো হয়েছে', {
      description: comment
    });
    navigate('/admin/review');
  };
  return <div data-id="element-956" data-mp="2c6b6zo0yyjqu">
      <PageHeader screen="WEB SCREEN 07" title="প্রসিকিউশন তথ্য যাচাই" subtitle="মেকার-চেকার নীতি: তথ্য সংশোধনকারী ও যাচাইকারী ভিন্ন কর্মকর্তা" actions={<StatusBadge label="চেকার: যাচাইকারী কর্মকর্তা" tone="success" data-id="element-958" data-mp="234aaitdk81q8" />} data-id="element-957" data-mp="2c3f8nyl7lt1v" />
      <WorkflowStepper current={3} data-id="element-959" data-mp="275dp7cjvfrpv" />

      <div className="grid gap-6 xl:grid-cols-[1fr_1fr_340px]" data-id="element-960" data-mp="278i351n521tq">
        <Panel title="মূল নোটিশ" bodyClassName="bg-slate-100 p-4" data-id="element-961" data-mp="1te8oe74rotdy">
          <A4Frame data-id="element-962" data-mp="1y68vcjj98mk1"><ScannedNotice data-id="element-963" data-mp="1y60haobebb79" /></A4Frame>
        </Panel>

        <Panel title="সংশোধিত তথ্য" bodyClassName="p-0" data-id="element-964" data-mp="1y7tqobde89iy">
          <table className="w-full text-sm" data-id="element-965" data-mp="1jhvub85b8dio">
            <tbody data-id="element-966" data-mp="1jezx5m1adsva">
              {ocrFields.map(f => <tr key={f.key} className="border-b border-border last:border-0" data-id="element-967" data-mp="1ogpaj8bzeimj">
                  <th className="w-[38%] bg-[#F4F7FB] px-4 py-2.5 text-left text-xs font-medium text-slate-600" data-id="element-968" data-mp="1afwe2i24ddgs">{f.label}</th>
                  <td className="px-4 py-2.5" data-id="element-969" data-mp="1fepuai8sjikn">
                    <div className={f.key === 'caseNo' ? 'font-mono text-[13px]' : ''} data-id="element-970" data-mp="vt7fqjjlt6bz">{record[f.key]}</div>
                    {correctedKeys.includes(f.key) && <span className="text-[11px] text-[#1769AA]" data-id="element-971" data-mp="qvo0phf30piz">অপারেটর কর্তৃক সংশোধিত</span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Panel>

        <div className="space-y-6" data-id="element-972" data-mp="10qz7ndk90sg6">
          <Panel title="যাচাই চেকলিস্ট" data-id="element-973" data-mp="1esbn7nvhys1j">
            <ul className="space-y-2.5" data-id="element-974" data-mp="1er9zaitdub2e">
              {checklist.map((c, i) => <li key={c} data-id="element-975" data-mp="19tqj3dd4jo7t" data-mpi={i}>
                  <label className="flex cursor-pointer items-center gap-3 rounded-md border border-border px-3 py-2.5 hover:bg-[#F4F7FB]" data-id="element-976" data-mp="19sp9zefo5bsq">
                    <input type="checkbox" className="h-4 w-4 accent-[#16834A]" checked={checked[i]} onChange={() => {
                  setError('');
                  setChecked(s => s.map((v, j) => j === i ? !v : v));
                }} data-id="element-977" data-mp="1jj1r0wo9ymu4" />
                    <span className="text-sm" data-id="element-978" data-mp="1xggjka9traqb">{c}</span>
                    {checked[i] && <CheckCircle2 className="ml-auto h-4 w-4 text-[#16834A]" data-id="element-979" data-mp="1slaytes5s23t" />}
                  </label>
                </li>)}
            </ul>
            <button className="mt-2 text-xs font-medium text-[#1769AA] hover:underline" onClick={() => setChecked(checklist.map(() => true))} data-id="element-980" data-mp="3ryhwu3fyxdrk">সকল নির্বাচন করুন</button>
          </Panel>

          <Panel title="পর্যালোচনা তথ্য" data-id="element-981" data-mp="4lpdsf5n6zmw">
            <dl className="space-y-2 text-sm" data-id="element-982" data-mp="4knu5mak94tk">
              <div className="flex justify-between" data-id="element-983" data-mp="3412ld50gobrp"><dt className="text-slate-500" data-id="element-984" data-mp="34245s03daam3">OCR Confidence Score</dt><dd className="font-semibold text-[#16834A]" data-id="element-985" data-mp="3905oul0sm9xk">৯৩%</dd></div>
              <div className="flex justify-between" data-id="element-986" data-mp="390ffmatnwl4b"><dt className="text-slate-500" data-id="element-987" data-mp="3d20pdnawgjaa">সংশোধিত ক্ষেত্র</dt><dd className="font-semibold" data-id="element-988" data-mp="3d07hy5sgpv18">{toBn(correctedKeys.length)}টি</dd></div>
              <div className="flex justify-between gap-3" data-id="element-989" data-mp="3i1n27vmtfxik"><dt className="text-slate-500" data-id="element-990" data-mp="3hyhdwim0gznw">পর্যালোচনাকারী</dt><dd className="text-right font-medium" data-id="element-991" data-mp="sai49w3hwfa4">{user?.name}</dd></div>
              <div className="flex justify-between" data-id="element-992" data-mp="xa3e51k7e81m"><dt className="text-slate-500" data-id="element-993" data-mp="x9bl9yhzqof1">পর্যালোচনার তারিখ</dt><dd data-id="element-994" data-mp="17ea2g2wzp9xm">১৪/০৬/২০২৫</dd></div>
            </dl>
            <label className="mt-4 block" data-id="element-995" data-mp="17e1kvxpx9gg3">
              <span className="mb-1 block text-sm font-medium" data-id="element-996" data-mp="12fqejwyu5o2m">মন্তব্য</span>
              <Textarea rows={3} value={comment} onChange={e => {
              setComment(e.target.value);
              setError('');
            }} placeholder="যাচাই সংক্রান্ত মন্তব্য লিখুন" data-id="element-997" data-mp="12ht1g84oz134" />
            </label>
            {error && <p role="alert" className="mt-2 text-xs text-[#D93036]" data-id="element-998" data-mp="tl29o7x6a8ec">{error}</p>}
            <div className="mt-4 grid gap-2" data-id="element-999" data-mp="opmxrliq6mkk">
              <Button onClick={validate} className="bg-[#16834A] hover:bg-[#126c3d]" data-id="element-1000" data-mp="joz04gzzr7hd"><ShieldCheck className="h-4 w-4" data-id="element-1001" data-mp="jr1wrjvnfyv2" /> যাচাইকৃত হিসেবে চিহ্নিত করুন</Button>
              <Button variant="outline" onClick={sendBack} data-id="element-1002" data-mp="eqe4kuvopbz9"><CornerUpLeft className="h-4 w-4" data-id="element-1003" data-mp="aok86ysiuu4w" /> সংশোধনের জন্য ফেরত পাঠান</Button>
              <Button variant="ghost" className="text-[#D93036]" onClick={() => setCancelOpen(true)} data-id="element-1004" data-mp="aqn6e63tvtkp"><XCircle className="h-4 w-4" data-id="element-1005" data-mp="291swnic63ni6" /> বাতিল করুন</Button>
            </div>
          </Panel>
        </div>
      </div>

      <Dialog open={cancelOpen} onOpenChange={setCancelOpen} data-id="element-1006" data-mp="2fwo4c9bm407">
        <DialogContent data-id="element-1007" data-mp="2ebuqpyqsr3x">
          <DialogHeader data-id="element-1008" data-mp="76d15v98bnm1">
            <DialogTitle data-id="element-1009" data-mp="76wm7ku6es4a">রেকর্ড বাতিল নিশ্চিত করুন</DialogTitle>
            <DialogDescription data-id="element-1010" data-mp="787ofg7z3rta">বাতিলকৃত রেকর্ড থেকে QR নোটিশ তৈরি হবে না। এই কার্যক্রম অডিট লগে সংরক্ষিত হবে।</DialogDescription>
          </DialogHeader>
          <DialogFooter data-id="element-1011" data-mp="3tmzej1hc469d">
            <Button variant="outline" onClick={() => setCancelOpen(false)} data-id="element-1012" data-mp="3tm7jpsvkack5">ফিরে যান</Button>
            <Button variant="destructive" onClick={() => {
            setCancelOpen(false);
            toast.error('রেকর্ড বাতিল করা হয়েছে (ডেমো)');
            navigate('/admin/notices');
          }} data-id="element-1013" data-mp="l6nsezegb47q">বাতিল নিশ্চিত করুন</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>;
}